//#region src/utils/groupPosition.ts
function e(e, t) {
	return t === 1 ? "single" : e === 0 ? "first" : e === t - 1 ? "last" : "middle";
}
//#endregion
export { e as getGroupPosition };
